import { render } from "./PedidoTelasView.vue?vue&type=template&id=12a3170c"
import script from "./PedidoTelasView.vue?vue&type=script&lang=js"
export * from "./PedidoTelasView.vue?vue&type=script&lang=js"

import "./PedidoTelasView.vue?vue&type=style&index=0&id=12a3170c&lang=css"

import exportComponent from "D:\\laragon\\www\\balkum-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__